webpackJsonp([1],{

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
const messages = {
  message: {
    appTitle: 'Presenta un reclamo riguardante il bagaglio',
    headerLogoAlt: 'Damaged luggage',
    headerEmailIconAlt: 'Ci invii un\'e-mail',
    backButton: 'Indietro',
    nextButton: 'Avanti',
    deleteButton: 'Elimina',
    cancelButton: 'Annulla',
    yesButton: 'Sì',
    noButton: 'No',
    backToStart: 'Torna all\'inizio',
    chatTitle: '',
    chatSubTitle: '',
    datePlaceholderText: 'Seleziona la data',
    selectPlaceholderText: 'Selezionare',
    formErrorTitle: 'Errore modulo',
    formErrorMessage: 'Si prega di correggere eventuali errori del modulo per continuare',
    gdpr: {
      nextButtonText: 'Prosegui con il reclamo'
    },
    claimType: {
      title: 'Come possiamo aiutarla?'
    },
    dataPreparation: {
      completeFormSentence: 'La preghiamo di accertarsi di aver compilato il modulo doganale e di imbucarlo nella cassetta alla Sua destra.',
      airportDeliverySentence: 'Senza una dichiarazione doganale compilata non saremo in grado di rimuovere il Suo bagaglio dall\'aeroporto per organizzare la consegna.',
      pleaseContinue: 'Una volta compilata, fare clic su Avanti per continuare.',
    },
    boardingPassScan: {
      scanToGetStarted: 'Scansioni la sua carta d\'imbarco per iniziare',
      pleaseScanDescriptionText: 'Scansioni il codice a barre o il codice QR della sua carta d\'imbarco per iniziare il processo di richiesta.',
      noBoardingPass: 'Non ha una carta d\'imbarco?',
      enterFlightDetailsManually: 'Inserisca manualmente i dati del volo'
    },
    boardingPassConfirm: {
      weFoundFollowingDetails: 'Abbiamo trovato i seguenti dati',
      name: 'Nome',
      flightNumber: 'Volo num',
      dateOfFlight: 'Data del volo',
      departureAirport: 'Aeroporto di partenza',
      arrivalAirport: 'Aeroporto di arrivo',
      areAboveDetailsCorrect: 'I dati riportati sopra sono corretti?',
      yesProceedButton: 'Sì, procedere',
      noScanAgainButton: 'No, eseguire nuovamente la scansione',
      enterFlightDetailsManually: 'Inserisca manualmente i dati del volo'
    },
    about: {
      title: 'I suoi dati',
      firstName: 'Nome',
      surname: 'Cognome',
      emailAddress: 'Email',
      phoneNumber: 'Telefono',
      phoneNumber2: 'Telefono 2',
      country: 'Paese',
      fiscalCode: 'Codice fiscale',
      address: 'Indirizzo',
      addressLine1: 'Indirizzo riga 1',
      addressLine2: 'Indirizzo riga 2',
      addressLine3: 'Indirizzo riga 3',
      nameOnDoorBuzzer: 'Nome sul citofono',
      city: 'Città',
      county: 'Provincia',
      postcode: 'CAP',
      selectAddressPlaceholderText: 'Seleziona l\'indirizzo',
      searchDifferentAddress: 'Cerchi un indirizzo diverso',
      manualAddress: 'Inserisca l\'indirizzo manualmente',
      editAddress: 'Modifichi l\'indirizzo'
    },
    address: {
      homeAddressTitle: 'Indirizzo di residenza',
      tempAddressTitle: 'Indirizzo durante la sua visita',
      differentAddress: 'Si trova in visita a un indirizzo temporaneo?',
      dateTempAddress: 'Ultima data presso l\'indirizzo temporaneo',
      plannedTravel: 'Ha in programma di viaggiare a breve?',
      plannedTravelDate: 'Quando ha in programma di viaggiare?'
    },
    flightDetails: {
      title: 'Dati del volo',
      bookingRef: 'Rif. prenotazione',
      flightRef: 'Volo num',
      flightDate: 'Data del volo',
      findAFlightButton: 'Ricerca volo',
      findClaimButton: 'Ricerca dettagli del reclamo',
      incidentLabel: 'Il reclamo è stato effettuato in aeroporto?',
      pirRefLabel: 'PIR number (report reference number)',
      pirRef: 'PIR',
      dateReported: 'Data reclamo',
      flightFinderInProgress: 'Stiamo cercando il volo...',
      flightClaimInProgress: 'Ricerca reclamo....',
      findClaimErrorHeading: 'Non è stato possibile trovare i dettagli del suo reclamo',
      findClaimErrorMessage: 'Si prega di verificare i dettagli sopra riportati e riprovare. Se non si riesce a trovare i dettagli del reclamo, è comunque possibile inviare manualmente il modulo riportato di seguito',
      findClaimSuccessHeading: 'Il suo reclamo è stato individuato correttamente',
      findClaimSuccessMessage: 'Procedere con la presentazione del reclamo di seguito',
      flightFinderSuccessHeading: 'In partenza',
      flightFinderSuccessMessageJoiner: 'a',
      flightFinderErrorIconAlt: 'Errore',
      flightFinderErrorHeading: 'Non siamo riusciti a trovare il suo volo',
      flightFinderErrorMessage: 'Controlli i dettagli in alto e riprovi. Se non riesce a trovare il suo volo, può comunque inviare tali dettagli, tuttavia questo potrebbe comportare tempi di elaborazione del reclamo più lunghi.',
      flightFinderErrorCheckboxLabel: 'Invia il mio reclamo utilizzando i dati in alto',
      clearFlightFinderIconAlt: 'Ripristina',
      clearFlightFinderMessage: 'Ripristina e trova un altro volo',
      arrivalAirport: 'Aeroporto di arrivo',
      departureAirport: 'Aeroporto di partenza',
      workOrderNumber: 'Numero dell\'ordine',
      bookingRefIconAlt: 'Numero di riferimento prenotazione o numero dell\'ordine',
      bookingRefInfoHeader: 'Numero di riferimento prenotazione o numero dell\'ordine',
      bookingRefInfoParagraph: 'Alcune compagnie aeree potrebbero fornirle un numero d\'ordine invece di un numero di riferimento prenotazione.'
    },
    addClaimsItem: {
      title: 'Aggiungere un articolo danneggiato',
      itemTypeLabel: 'Tipo reclamo',
      baggageButton: 'Bagaglio',
      contentsButton: 'Contenuto',
      addToClaimButton: 'Aggiungi al reclamo',
      saveToClaimButton: 'Salva'
    },
    replacementItem: {
      title: 'Risarcimento',
      notRepairable: 'Sembra che il danno sia irreparabile.',
      chooseReplacement: 'Scelga un articolo sostitutivo:',
      noReplacementText: 'Nessun articolo sostitutivo - desidero parlare con un operatore. Questo potrebbe comportare tempi di elaborazione del reclamo più lunghi.',
      noReplacementOptions: 'Purtroppo non sono state trovate opzioni per la sostituzione di questo bagaglio. Una sostituzione o riparazione del suo bagaglio sarà valutata da un operatore in un secondo momento.',
      chooseReplacementColour: 'Scelga il suo colore preferito.',
      chooseReplacementAltColour: 'Scelga altri colori che accetterebbe.',
      disclaimerHeader: 'Esclusione da responsabilità',
      additionalInfo: 'Se desidera fornirci ulteriori dettagli, nella pagina successiva troverà una casella per i commenti.',
      disclaimerText: 'Questa è una rappresentazione del bagaglio che riceverà. Anche se saranno offerte tutte le caratteristiche che vede, potrebbero esserci dei cambiamenti nell\'aspetto e nel design.',
      advisoryText: 'La informiamo che la sostituzione da lei selezionata potrebbe essere soggetta a modifiche nel caso in cui il nostro team di esperti ritenga che ce ne sia una più adatta al suo articolo danneggiato. '
    },
    baggageItem: {
      type: 'Tipo',
      tagNumber: 'Etichetta bagaglio num',
      brand: 'Nome marchio',
      colour: 'Colore',
      dimensionsIllustration: 'Misuri la sua valigia dall\'estremità inferiore a quella superiore (comprese le rotelle).',
      dimensionsInfoIconAlt: 'Informazioni sulle dimensioni',
      dimensionsBaggageIconAlt: 'Schema delle dimensioni del bagaglio',
      height: 'Altezza (cm)',
      length: 'Lunghezza (cm)',
      material: 'Tipologia',
      proofOfDamagesTitle: 'Prova dei danni',
      costTitle: 'Costo originario',
      datePurchased: 'Data di acquisto',
      receiptNote: 'Aggiungere una ricevuta aiuta ad elaborare il reclamo più velocemente.',
      receiptButton: 'Allega ricevuta',
      wheels: 'Ruote',
      locks: 'Chiusure',
      morePhotos: 'Aggiungere altre foto',
      wholeCaseUpload: 'Foto che mostra l\'intera scocca o borsa',
      wholeCaseUploadBuggyType: 'Foto che mostra l\'intero oggetto',
      badgeUpload: 'Foto che mostra il marchio sulla scocca o la borsa',
      badgeUploadBuggyType: 'Foto che mostra il marchio dell\'articolo',
      baggageTagUpload: 'Foto che mostra l\'etichetta del bagaglio',
      areaOfDamageUpload: {
        caption: 'Una foto di ciascuna area danneggiata',
        selectPlaceholder: 'Selezionare il danno',
        selectOptions: {
          top: 'Alto',
          bottom: 'Basso',
          left: 'Sinistra',
          right: 'Destra'
        }
      },
      price: 'Prezzo',
      isExpandable: 'L\'articolo è espandibile',
      damageType: 'Tipo di danno',
      model: 'Modello',
      serialNumber: 'Numero di serie'
    },
    contentsItem: {
      name: 'Articolo danneggiato',
      damageDesc: 'Danno sostenuto',
      proofOfDamagesTitle: 'Prova dei danni',
      costTitle: 'Costo originario',
      datePurchased: 'Data di acquisto',
      receiptNote: 'Aggiungere una ricevuta aiuta a ridurre i tempi di elaborazione.',
      receiptButton: 'Carica ricevuta',
      morePhotos: 'Aggiungere altre foto',
      wholeItemUpload: 'Foto che mostra l\'articolo danneggiato nella sua interezza',
      areaOfDamageUpload: {
        caption: 'Foto che mostra l\'articolo danneggiato nella sua interezza',
        selectPlaceholder: 'Selezionare il danno',
        selectOptions: {
          top: 'Alto',
          bottom: 'Basso',
          left: 'Sinistra',
          right: 'Destra'
        }
      }
    },
    claimsItemsSummary: {
      title: 'Articoli esistente',
      deleteItemTitle: 'Confermare di voler cancellare l\'articolo',
      deleteConfirmationMessage: 'È sicuro di volerlo cancellare',
      addButton: 'Aggiungi articolo'
    },
    claimsItem: {
      photo: 'foto',
      photos: 'foto',
      receipt: 'ricevuta aggiunta',
      receipts: 'ricevute aggiunte',
      deleteItem: 'Elimina articolo',
      editItem: 'Modifica articolo'
    },
    submitClaim: {
      title: 'Inviare il reclamo',
      additionalInfo: 'Ulteriori informazioni',
      additionalInfoPlaceholder: 'Ci comunichi eventuali informazioni aggiuntive su questo reclamo che vorrebbe che noi prendessimo in considerazione',
      termsCheckboxLabelPrefix: 'Accetto i',
      termsCheckboxLabel: 'termini e condizioni.',
      infoConfirmationCheckboxLabel: 'Confermo che tutte le informazioni che ho fornito sono corrette.',
      submitClaimButton: 'Invia reclamo',
      submitClaimError: 'Errore durante l\'invio. Riprovi.',
      whatsNextTitle: 'Qual è il prossimo passo?',
      keepLuggageLabelPrefix: 'Si assicuri di ',
      keepLuggageLabel: 'non gettare il suo bagaglio danneggiato',
      keepLuggageLabelSuffix: 'in quanto le chiederemo di fornire prove fotografiche.',
      waitForConfirmationLabel: 'Una volta inoltrata la richiesta, il nostro team si metterà in contatto con lei per confermare le fasi successive e le eventuali prove necessarie.',
      infoIconAlt: 'Punto esclamativo - Informazioni',
      requiredBaggageIconAlt: 'Sono necessarie foto del bagaglio'
    },
    submitSuccess: {
      title: 'Reclamo inviato',
      header: 'La ringraziamo per aver presentato un reclamo',
      text: 'La sua richiesta è in corso di elaborazione.',
      refNumber: 'Il suo numero di riferimento è',
      emailSoon: 'A breve riceverà un\'e-mail che le confermerà il passaggio successivo.',
      buttonText: 'Torna alla Home',
      pageWillCloseTitle: 'Questa pagina si chiuderà automaticamente tra',
      pageWillCloseSeconds: 'secondi'
    },
    makeDelayedClaim: {
      title: 'Fare un reclamo per bagaglio in ritardo',
      header: 'Eseguire la scansione del codice QR riportato sotto e compilare il modulo',
      buttonText: 'Torna all\'inizio',
    },
    claimStatus: {
      title: 'Stato del reclamo',
      statusPageTitle: 'Sintesi del reclamo',
      messagesPageTitle: 'Messaggi relativi al reclamo',
      claimUpdateItemTitle: 'Aggiungere le immagini richieste',
      summaryHeader: 'Riepilogo del reclamo',
      help: 'Per richiedere assistenza, la preghiamo di rispondere o di contattarci su www.damagedluggage.com usando la Live Chat',
      phoneIconAlt: 'Aiuto',
      missingDataIconAlt: 'Errore',
      missingDataHeading: 'Completi le informazioni mancanti',
      missingDataMessage: 'Abbiamo bisogno di ulteriori informazioni per elaborare il suo reclamo per i seguenti articoli:',
      updateClaimButton: 'Aggiorna la richiesta',
      errorHeader: 'Errore di caricamento',
      errorMessage: 'Si è verificato un errore durante il tentativo di caricare lo stato del suo reclamo. Riprovi.',
      claimRef: 'Claim reference',
      claimMade: 'Data di presentazione del reclamo',
      flightDate: 'Data del volo',
      baggageItems: 'Bagagli',
      itemNoMissingData: 'Questo reclamo non ha dati mancanti.',
      replacementItemsRequiresConfirmation: 'Confermi gli articoli sostitutivi',
      replacementItemsRequiresConfirmationMessage: 'Si prega di confermare gli articoli sostitutivi.',
      claimStatusUpdate: 'Aggiornamento sullo stato del reclamo',
      replacementItemsConfirmation: {
        title: 'Articoli sostitutivi',
        singleItemReplacement: 'La preghiamo di rivedere la seguente sostituzione',
        multipleItemReplacement: 'La preghiamo di rivedere le seguenti sostituzioni',
        confirmText: 'Confermare l\'offerta.',
        declineText: 'Rifiutare l\'offerta. Desidero parlare con un operatore.',
        declineModalTitle: 'Rifiutare',
        declineModalText: 'Desidera fornirci un motivo?',
        declineModalWarning: 'Rifiutare questa sostituzione potrebbe comportare tempi di elaborazione del reclamo più lunghi.',
        confirmButtonText: 'Conferma',
        declineButtonText: 'Rifiuta'
      },
      actionRequiredTitle: 'Azione richiesta',
      actionRequiredText: 'Abbiamo bisogno di ulteriori informazioni per elaborare ulteriormente il suo reclamo.',
      titleMessages: 'Ultimo messaggio',
      viewMessages: 'Messaggi',
      newMessage: 'Risposta',
      noMessages: 'Non sono stati aggiunti messaggi al suo reclamo. Ricontrolli presto.',
      messageClientPrefix: 'Lei',
      messageAdminPrefix: 'Team Damaged Luggage',
      newMessageModalTitle: 'Nuovo messaggio',
      newMessageModalSendButton: 'Inviare',
      titleDocuments: 'Carica un documento',
      sendDocument: 'Invia un documento'
    },
    postcodeLookup: {
      errorMessages: {
        invalid: 'Formato del CAP non valido - Riprovi',
        notFound: 'Impossibile trovare il CAP - Riprovi'
      },
      defaults: {
        buttonText: 'Trova indirizzo',
        placeholder: 'CAP'
      }
    },
    verification: {
      pageTitle: 'Verifica',
      verificationCode: 'Codice di verifica',
      sendNewVerificationCode: 'Le serve un nuovo codice di verifica?',
      newCodeSuccess: 'La preghiamo di controllare la sua e-mail.',
      newCodeFailed: 'Errore, si prega di riprovare.'
    },
    screensaver: {
      title: 'Segnalare il ritardo o il danneggiamento di un bagaglio.',
      selectLanguage: 'Seleziona la lingua',
      getStarted: 'Iniziare'
    },
    apiTranslations: {
      'An invalid code has been entered too many times.\nPlease request a new code and try again.': 'È stato inserito un codice non valido troppe volte. Richieda un nuovo codice e riprovi.',
      'Buggy': 'Buggy',
      'Claim not found.\nPlease contact support for help.': 'Reclamo non trovato.\n:Contattare l\'assistenza per ricevere aiuto.',
      'Golf Travel Bag': 'Golf Travel Bag',
      'Hard Shell Golf Case': 'Hard Shell Golf Case',
      'Hard Shell Traditional Style Case' : 'Hard Shell Traditional Style Case ',
      'Hard Shell Trolley Suitcase': 'Hard Shell Trolley Suitcase',
      'Holdall': 'Holdall',
      'Missing claim identifier.\nPlease contact support for help.': 'Identificatore della richiesta mancante. Contatti l\'assistenza.',
      'Missing verification code.\nPlease contact support for help.': 'Codice di verifica mancante.\nContatti l\'assistenza.',
      'Our records show your claim to now be resolved.  You can still get in touch with a message below if you need us.': 'I dati in nostro possesso mostrano che la sua richiesta è stata risolta. Se ha bisogno di noi, può comunque contattarci inviando un messaggio in basso.',
      'Please respond to the below message to progress your claim.': 'La preghiamo di rispondere al messaggio in basso per procedere con il suo reclamo.',
      'RuckSack': 'RuckSack',
      'Soft Shell Trolley Suitcase': 'Soft Shell Trolley Suitcase',
      'This claim has been closed.\nPlease contact support for help.': 'Questo reclamo è stato chiuso.\nContattare l\'assistenza per ricevere aiuto.',
      'This code has now expired.\nPlease request a new code and try again.': 'Questo codice è scaduto. Richieda un nuovo codice e riprovi.',
      'This code is unrecognised.\nPlease double check your code or request a new code and try again.': 'Questo codice non è stato riconosciuto. Ricontrolli il suo codice o ne richieda uno nuovo e riprovi.',
      'Your claim has been passed to our accounts team.  We aim to process payments within 14 working days where possible.': 'Il suo reclamo è stato trasmesso al team responsabile della contabilità. Se possibile, cercheremo di elaborare i pagamenti entro 14 giorni lavorativi.',
      'Your claim has been rejected as your claim was submitted more than 7 days after the damage date.': 'Il suo reclamo è stato respinto perché presentato oltre 7 giorni dopo la data del danno.',
      'Your claim has been rejected.': 'Il suo reclamo è stato respinto.',
      'Your claim is being handled by our warehouse team who are getting your item ready for despatch.': 'Il suo reclamo è gestito dal team responsabile del magazzino, che sta preparando il suo articolo per la spedizione.',
      'Your claim is being reviewed, we will be in touch when we have an update for you.': 'Il suo reclamo è in fase di verifica; la contatteremo non appena avremo notizie al riguardo.',
      'Your item has been despatched.': 'Il suo articolo è stato spedito.',
      'Your replacement bag is currently out of stock. There is no need for you to do anything at this time we will send your luggage as soon as it is in stock.': 'La sua valigia sostitutiva non è attualmente disponibile. In questo momento non è necessario che faccia nulla, le invieremo il bagaglio non appena sarà disponibile in magazzino.'
    }
  }
}
/* harmony default export */ __webpack_exports__["default"] = (messages);


/***/ })

});


// WEBPACK FOOTER //
// static/js/1.81a10cd2040a51e15a35.js